import { OgqlViewDetail } from '@opengov/ogql-client/records';
import { enumActiveNavigationPanelFilter } from '../../../src/types/MultiDatasetTypes';
import { EReportChartType } from '@opengov/reporting-types';
import { Map, Record } from 'immutable';

import { DataTableStatus, IReportExplorerState, SettingsCardMode } from '../types';

export const ReportExplorerState = Record<IReportExplorerState>({
  activeNavigationPanelFilter: enumActiveNavigationPanelFilter.ROOT,
  activeTab: 'explorer',
  agGridCacheBuster: 0,
  agGridColumns: null,
  agGridParentData: null,
  allowedActions: Map<string, boolean>(),
  chartType: EReportChartType.VerticalBar,
  filterValuesByColumn: Map<string, Map<string, number>>(),
  currentView: OgqlViewDetail(),
  dataTableStatus: DataTableStatus.Loading,
  dataTableTotalRowCount: null,
  dimensionalColumns: null,
  dimensionalGroupRowData: null,
  dimensionalReportConfiguration: null,
  dimensionalTableQueryStatuses: [],
  editorDrawerOpen: true,
  editMode: null,
  fetchingPdfExportData: false,
  initialized: false,
  isEditModeDirty: false,
  isRefreshRowData: false,
  isRefreshRowKeepingCache: false,
  newColumnGroupType: null,
  paginationOffset: null,
  pdfExportData: { detailTableData: [], detailTableTotalsData: [], accountSummaryTableData: [] },
  pdfExportTooMuchData: false,
  pivotColumns: null,
  pivotColumnGroupIds: null,
  isLoadingReportDatasetLenses: false,
  reportDatasetLenses: null,
  reportTotalRowCount: null,
  selectedColumnEditorLensId: null,
  selectedColumnGroupIndex: null,
  selectedSegment: null,
  selectedColumnPath: null,
  selectedColumnLevel: null,
  selectedSource: null,
  selectedRowGroupIndex: null,
  newRowGroupType: null,
  settingsAboutCardMode: SettingsCardMode.DefaultRead
});
